module.exports = new __parcel__URL__("app-preview.701bd916.svg").toString();